// third-party
import { IconUserSquareRounded } from '@tabler/icons-react';
import { FormattedMessage } from 'react-intl';

const icons = {
    IconUserSquareRounded
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const customerManagement = {
    id: 'Customer Management',
    title: <FormattedMessage id="Customer Management" />,
    icon: icons.IconUserSquareRounded,
    type: 'group',
    children: [
        {
            id: 'Customers',
            title: <FormattedMessage id="Customers" />,
            type: 'item',
            url: '/customers/list',
            icon: icons.IconUserSquareRounded,
            breadcrumbs: false
        },
    ]
};

export default customerManagement;